import { render } from "./AIMLModels.vue?vue&type=template&id=519fdfef"
import script from "./AIMLModels.vue?vue&type=script&lang=js"
export * from "./AIMLModels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__